import axios from 'axios';
import {
  FETCH_LEDGER_SUCCESS,
  FETCH_LEDGER_FAIL,
  FETCH_DAILY_LEDGER_SUCCESS,
  FETCH_DAILY_LEDGER_FAIL,
} from './types';

export const fetchLedger = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/ledger';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_LEDGER_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_LEDGER_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_LEDGER_FAIL });
  }
};

export const fetchDailyLedger = (params, id) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/ledger/daily/';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_DAILY_LEDGER_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_DAILY_LEDGER_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_DAILY_LEDGER_FAIL });
  }
};
